import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('userFormFields');

    return {
        ROLES_FIELD_PLACEHOLDER: t('rolesFieldPlaceholder')
    };
};

export default useTranslation;
